import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import HeartRunnerListComponent from '../components/heartRunnerListComponent';
import { loggedIn, logout, logOutAdmin } from '../../../SuperAdminLogin/actions/superAdminLoginAction'
import { fetchHeartRunnerDetail,
        deleteHeartRunnerDetail,
         disableHeartRunnerDetail,
         enableHeartRunnerDetail,
          updateHeartRunnerDetail,
          updatePasswordDetail,
          updateAlarmSettings,
          resetDeviceKey,
          userLogout,removeProfilePic,getAllRegionSettings,getPermissionsListFunc
        } from '../actions/heartRunnerListAction';
import {getCountryListFunc,getRegionListFunc} from '../actions/heartRunnerAction';

class HeartRunnerListContainer extends Component {
    
    componentWillMount() {
        let OrganizationID=this.props.match.params.id
        
           /*  this.props.actions.fetchHeartRunnerDetail(
                OrganizationID,
            this.props.dispatch) */
              this.props.actions.getAllRegionSettings();
    }
    componentDidMount() {
        this.props.actions.getCountryListFunc(
        this.props.dispatch)
         this.props.actions.getRegionListFunc(
        this.props.dispatch)
        this.props.actions.getAllRegionSettings();
        this.props.actions.getPermissionsListFunc(
                    this.props.dispatch
                )
    }
      getRegion = () =>{
            this.props.actions.getAllRegionSettings(
                this.props.dispatch
            )
            
        }
      
       getRegionData = () => {
              this.props.actions.getAllRegionSettings(this.props.dispatch);
           } 
      
        getUserList = (data) =>{
            this.props.actions.fetchHeartRunnerDetail(data,
                this.props.dispatch
            )
        }
      
       getUserListData = (data) => {
              this.props.actions.fetchHeartRunnerDetail(data,this.props.dispatch);
           }
    getList=() =>{
        let OrganizationID=this.props.match.params.id
        this.props.actions.fetchHeartRunnerDetail(
            OrganizationID,
        this.props.dispatch)
    }
    onDelete=(SelectedRow,regionId)=> {
        
        this.props.actions.deleteHeartRunnerDetail(
            this.props.heartRunnerList.isLoading,
            SelectedRow,regionId,
            this.props.dispatch
            )
    }

    onDisable=(SelectedRow)=> {
        let data={
            HeartRunnerIdList:SelectedRow,
            IsEnabled:0,
        }
       
        this.props.actions.disableHeartRunnerDetail(
            this.props.heartRunnerList.isLoading,
            data,
            this.props.dispatch)
    }
    onEnable=(SelectedRow)=> {
        let data={
            HeartRunnerIdList:SelectedRow,
            IsEnabled:1,
        }
       
        this.props.actions.enableHeartRunnerDetail(
            this.props.heartRunnerList.isLoading,
            data,
            this.props.dispatch)
    }
    updateHeartRunnerDetails=(formData) =>{
        this.props.actions.updateHeartRunnerDetail(
            formData, 
            this.props.dispatch
        )
    }
    removeProfilePicture=(formData,RegionId) =>{
        this.props.actions.removeProfilePic(
            formData,RegionId,   
            this.props.dispatch
        )
    }
    updatePassword=(formData,RegionId) =>{
        this.props.actions.updatePasswordDetail(
            formData,RegionId, 
            this.props.dispatch
        )
    }
    updateAlarmSettings=(formData,RegionId)=>{
        this.props.actions.updateAlarmSettings(
            formData,RegionId,
            this.props.dispatch
        ) 
    }
    resetDeviceKey=(formData) =>{
        //debugger
        this.props.actions.resetDeviceKey(
            this.props.heartRunnerList.isLoading,
            formData, 
            this.props.dispatch
        )
    }
    onLogout = (id,Region) => {
        this.props.actions.userLogout(
            id,Region,
            this.props.dispatch
        )
    }
    getUserList = (data) =>{
            this.props.actions.fetchHeartRunnerDetail(data,
                this.props.dispatch
            )
        }
    render() {
        return (
            <div className="agile-grids">
                <div className="grids">
                    <div className="container">
                        <div className="row">
                            
                            <HeartRunnerListComponent
                                heartRunnerList={this.props.heartRunnerList}
                                updateHeartRunnerDetails={this.updateHeartRunnerDetails}
                                removeProfilePicture ={this.removeProfilePicture}
                                updatePassword={this.updatePassword}
                                onDisable={this.onDisable}
                                onEnable={this.onEnable}
                                onDelete={this.onDelete}
                                updateAlarmSettings={this.updateAlarmSettings}
                                resetDeviceKey={this.resetDeviceKey}
                                getList = {this.getList}
                                onLogout = {this.onLogout}
                                getRegion ={this.getRegion}
                    getRegionList={this.getRegionData}
                    getUserList ={this.getUserList}
                            />
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

function mapDispatchToProps(dispatch) {
    return {
        dispatch: dispatch,
        actions: bindActionCreators({
            logOutAdmin, fetchHeartRunnerDetail, 
            deleteHeartRunnerDetail,
            disableHeartRunnerDetail,
            enableHeartRunnerDetail,
            updateHeartRunnerDetail,
            updatePasswordDetail,
            updateAlarmSettings,
            resetDeviceKey,
            userLogout,removeProfilePic,
            getCountryListFunc,
            getRegionListFunc,
            getAllRegionSettings,
            getPermissionsListFunc
        }, dispatch)
    };
};

function mapStateToProps({ heartRunnerReducer}) {
    console.log(heartRunnerReducer);
    return {
        heartRunnerList: {
            isLoading: heartRunnerReducer.isLoading,
            heartRunnerList: heartRunnerReducer.heartRunnerList,
            errorNumber: heartRunnerReducer.errorNumber,
            errorMessage: heartRunnerReducer.errorMessage,
            messageLabel: heartRunnerReducer.messageLabel,
            statusCode: heartRunnerReducer.statusCode,
            countryList : heartRunnerReducer.countryList,
            regionList : heartRunnerReducer.regionList,
            permissionList:heartRunnerReducer.permissionList
        },
        
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(HeartRunnerListContainer))